module.exports = __webpack_public_path__ + "img/mockup.8b6862cb.png";